import React from 'react';
import { AppBar, Toolbar, Container, Card, CardContent, CardMedia, Typography, Button, List, ListItem, Grid, Box, TextField, styled } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import ContactUsForm from '../../components/contactus/ContactUsForm';


const PageContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(8),
  marginBottom: theme.spacing(8),
}));

const SectionCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  boxShadow: theme.shadows[3],
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const ContactForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

function ExclusiveLeadsPage() {
  return (
    <>
      <LandingPageNav/>

      <PageContainer maxWidth="lg">
        {/* Exclusive Leads Section */}
        <SectionCard>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <CardMedia
                component="img"
                image="/assets/leadscreenshot.jpg"
                alt="Lead Screenshot"
                sx={{ width: '100%', height: 'auto' }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography variant="h5" component="div" gutterBottom>
                  EXCLUSIVE LEADS
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  STOP WASTING MONEY ON SUBPAR LEADS
                </Typography>
                <List>
                  <ListItem>Real Time, consumer requested, motivated HOT leads.</ListItem>
                  <ListItem>Interact with consumer instantly</ListItem>
                  <ListItem>Exclusive – Single Entity Authorization</ListItem>
                  <ListItem>Reliable and Quality</ListItem>
                  <ListItem>Flexible Options – Pay-Per-Lead and Workflow Model</ListItem>
                  <ListItem>We Provide, You Close</ListItem>
                </List>
              </CardContent>
            </Grid>
          </Grid>
        </SectionCard>

        {/* Contact Us Section */}
        <SectionCard>
        <ContactUsForm />
        </SectionCard>
      </PageContainer>
    </>
  );
}

export default ExclusiveLeadsPage;
